module.exports = __webpack_public_path__ + "img/tastings.30f4c721.png";